<template>
  <div class="contact-container">
    <!-- 主内容区 -->
    <div class="contact-grid">
      <!-- 联系方式区块 -->
      <div class="contact-info">
        <h2 class="section-title">Get in Touch</h2>

        <!-- 工厂信息面板 -->
        <div class="info-card factory-panel">
          <!-- 邮箱 -->
          <div class="info-item">
            <Icon fontName="email" class="icon-container" />
            <div>
              <h3>General Inquiries</h3>
              <p>
                <span style="font-size: 1.1rem; font-weight: 700"
                  >info@yoleecorp.com</span
                ><br />
                Typical response within 24 hours
              </p>
            </div>
          </div>

          <!-- 电话 -->
          <div class="info-item">
            <Icon fontName="tel" class="icon-container" />
            <div>
              <h3>Direct Line</h3>
              <p>
                +86 158-0399-0204<br />
                Mon – Fri, 9:00 AM – 5:00 PM<br />
                China Standard Time (UTC+8)
              </p>
            </div>
          </div>

          <h3 class="panel-title">Our Factory</h3>

          <!-- 工厂一 -->
          <div class="factory-block">
            <div class="factory-header">
              <Icon fontName="factory" class="factory-icon" />
              <div>
                <h4 class="factory-name">SHIXIAO MACHINERY</h4>
                <p class="factory-type">Manufacturer of Abrasive Machinery</p>
              </div>
            </div>
            <p class="factory-address">
              Huawei Road<br />
              Baizhai Town, Xinmi City<br />
              Zhengzhou, Henan, China(452300)
            </p>
          </div>

          <h3 class="panel-title">Exclusive Sales Representative</h3>

          <!-- 销售中心 -->
          <div class="factory-block">
            <div class="factory-header">
              <Icon fontName="factory" class="factory-icon" />
              <div>
                <h4 class="factory-name">YOLEE TECHNOLOGY</h4>
                <p class="factory-type">
                  Act as the exclusive sales representative of SHIXIAO Machinery
                </p>
              </div>
            </div>
            <p class="factory-address">
              No. 133 Yaozhai Road<br />
              Jinshui District<br />
              Zhengzhou, 450000, China(450000)
            </p>
          </div>
        </div>
      </div>

      <!-- 表单区块 -->
      <div class="form-wrapper">
        <h2 class="section-title">Send a Message</h2>

        <Form @submit-success="showSuccess" @submit-error="showError" />

        <!-- 提交反馈 -->
        <transition name="fade">
          <div v-if="showSuccessMessage" class="feedback success">
            <Icon fontName="success" class="icon-container" />
            Message sent successfully
          </div>
        </transition>

        <transition name="fade">
          <div v-if="showErrorMessage" class="feedback error">
            <Icon fontName="error" class="icon-container" />
            Please check the form and try again
          </div>
        </transition>
      </div>
    </div>

    <!-- YOLEE 介绍部分 -->
    <!-- YOLEE 介绍部分 -->
    <div class="yolee-bridge" ref="bridge">
      <div class="bridge-header">
        <Icon fontName="bridge" class="bridge-icon" />
        <h3 class="bridge-title">
          <span class="yolee">YOLEE®</span> — Role & Direction
        </h3>
      </div>

      <div class="bridge-content">
        <div class="bridge-section">
          <h4>Who We Are</h4>
          <p>
            <strong>YOLEE</strong> serves as the
            <strong>Exclusive Sales Representative (ESR)</strong> of SHIXIAO
            Machinery. Established as an independently operated LLC backed by
            SHIXIAO’s ownership, YOLEE is the factory-authorized organization
            for international sales, technical communication, and customer
            support.
          </p>
        </div>

        <div class="bridge-section">
          <h4>Our Mission</h4>
          <p>
            Bridge global manufacturers with engineering-led production
            partners, delivering clear technical communication and dependable
            supply. Our team spends time inside factory operations and conducts
            regular overseas visits — ensuring technical accuracy, fast
            response, and procurement transparency.
          </p>
        </div>

        <div class="bridge-section">
          <h4>Our Vision</h4>
          <p>
            Build long-term partnerships through quality, process knowledge, and
            responsible growth — not price-driven competition. YOLEE prioritizes
            stable quality, industry insight, and solutions that strengthen
            customers’ brand competitiveness.
          </p>
        </div>
      </div>
    </div>

    <!-- 隐私声明 -->
    <p class="privacy-notice">
      By submitting this form you agree to our
      <router-link to="/policy">Privacy Policy</router-link>. We never share
      your information with third parties.
    </p>
  </div>
</template>

<script>
import Form from "@/components/Form";
import Icon from "@/components/Icon";

export default {
  components: { Form, Icon },
  data() {
    return {
      showSuccessMessage: false,
      showErrorMessage: false,
    };
  },
  mounted() {
    this.$emit("set-product-page", true);
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    this.$emit("set-product-page", false);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    showSuccess() {
      this.showSuccessMessage = true;
      this.showErrorMessage = false;
      setTimeout(() => (this.showSuccessMessage = false), 5000);
    },
    showError() {
      this.showErrorMessage = true;
      this.showSuccessMessage = false;
    },
    handleScroll() {
      const el = this.$refs.bridge;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      if (rect.top < windowHeight * 0.85) {
        el.classList.add("in-view");
        el.querySelector(".bridge-content").classList.add("in-view");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

/* ========== GRID 布局 ========== */
.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 3rem;
  margin-bottom: 2rem;

  @media (max-width: @breakpoint-tablet) {
    grid-template-columns: 1fr;
  }
}

.section-title {
  color: @color-text-title;
  font: 600 28px/1.2 @font-en;
  margin-bottom: 2rem;
  border-bottom: 2px solid @color-primary;
  padding-bottom: 0.5rem;
}

/* ========== 信息卡片 ========== */
.info-card {
  background: @color-bg-light;
  .cardRadius();
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 6px 18px fade(@color-primary, 10%);
}

/* 工厂信息面板（工业风） */
.factory-panel {
  background: #f3f4f5;
  border: 1px solid fade(@color-text-title, 10%);
  border-radius: 14px;
  padding: 2.2rem;
}

.panel-title {
  font: 600 20px @font-en;
  margin-bottom: 2rem;
  color: @color-text-title;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  &:before {
    content: "";
    width: 50px;
    height: 3px;
    background: @color-primary;
    display: block;
    margin-bottom: 0.7rem;
    border-radius: 2px;
  }
}

/* 每个工厂 block */
.factory-block {
  background: white;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 6px 14px fade(@color-primary, 12%);
  margin-bottom: 1.6rem;
  border-left: 6px solid fade(@color-primary, 60%);
}

.factory-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.factory-icon {
  font-size: 2.2rem;
  color: @color-primary;
  flex-shrink: 0;
}

.factory-name {
  font: 700 18px/1.3 @font-en;
  color: @color-text-title;
}

.factory-type {
  font-size: 14px;
  color: @color-primary;
  margin-top: 2px;
}

.factory-address {
  margin-top: 0.3rem;
  color: @color-text-content;
  line-height: 1.6;
}

/* ========== 联系信息项 ========== */
.info-item {
  display: flex;
  gap: 1.2rem;
  margin-bottom: 2rem;

  .icon-container {
    font-size: 2rem;
    color: @color-primary;
    flex-shrink: 0;
  }

  h3 {
    color: @color-primary;
    font: 600 18px/1.3 @font-en;
    margin-bottom: 0.4rem;
  }

  p {
    color: @color-text-content;
    line-height: 1.6;
  }
}

/* ========== 表单区域 ========== */
.form-wrapper {
  position: relative;
  .cardRadius();
}

/* 反馈消息 */
.feedback {
  .flex-center();
  gap: 0.8rem;
  padding: 1rem;
  margin-top: 1.5rem;
  border-radius: 8px;
  font-weight: 500;

  &.success {
    background: fade(@color-status-success, 12%);
    color: @color-status-success;
  }

  &.error {
    background: fade(@color-status-error, 12%);
    color: @color-status-error;
  }

  .icon-container {
    font-size: 1.2rem;
  }
}

/* ========== YOLEE 介绍 ========== */
.yolee-bridge {
  background: linear-gradient(
    135deg,
    @color-bg-gray,
    lighten(@color-bg-gray, 6%)
  );
  padding: 3rem 2rem;
  border-radius: 16px;
  margin-bottom: 3rem;
  box-shadow: 0 10px 25px fade(@color-primary, 18%);
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;

  &.in-view {
    opacity: 1;
    transform: translateY(0);
  }
}

.bridge-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.bridge-icon {
  font-size: 3.2rem;
  color: @color-primary;
  flex-shrink: 0;
  animation: float 3.6s ease-in-out infinite;
}

.bridge-title {
  font: 700 26px @font-en;
  color: @color-text-title;

  .yolee {
    color: @color-primary;
    font-weight: 800;
  }
}

.bridge-content {
  color: @color-text-content;
  font-size: 16px;
  line-height: 1.75;

  .bridge-section {
    margin-bottom: 2rem;

    h4 {
      font-size: 18px;
      font-weight: 700;
      color: @color-primary;
      margin-bottom: 0.6rem;
    }

    p {
      margin: 0;
      text-indent: 0; // 去掉首行缩进，阅读更顺畅
    }
  }
}

/* 动画 */
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

/* ========== 隐私声明 ========== */
.privacy-notice {
  text-align: center;
  color: @color-text-sub;
  font-size: 14px;
  margin-top: 2rem;

  a {
    color: @color-primary;
    text-decoration: underline;
  }
}

/* ========== Mobile 优化 ========== */
@media (max-width: 768px) {
  .contact-container {
    padding: 1rem;
  }

  .bridge-icon {
    display: none;
  }

  .bridge-title {
    font-size: 20px;
  }

  .info-card,
  .form-wrapper {
    padding: 1.6rem;
  }

  .factory-block {
    padding: 1rem;
  }

  .bridge-content p {
    text-indent: 0;
    font-size: 15px;
  }
}
</style>
